import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import api, { errMsg } from "@/lib/api";

export default function CrearCuenta() {
  const { setSession, user } = useAuth();
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const token = sp.get("token") || "";
  const [form, setForm] = useState({ name: "", password: "", password2: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate("/mi-archivo"); }, [user]);
  useEffect(() => { if (!token) toast.error("Este enlace no es válido. Pedile a ARCHIVE LAB uno nuevo."); }, [token]);

  const valid = token && form.password.length >= 8 && form.password === form.password2;

  const submit = async (e) => {
    e.preventDefault();
    if (!valid) return toast.error(form.password.length < 8 ? "La contraseña necesita al menos 8 caracteres" : "Las contraseñas no coinciden");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/activate", { token, name: form.name, password: form.password });
      setSession(data.token, data.user);
      toast.success("¡Bienvenida al archivo!");
      navigate("/mi-archivo");
    } catch (err) {
      toast.error(errMsg(err));
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16" data-testid="crear-cuenta">
      <Logo />
      <h1 className="font-display text-4xl text-[#171719] mt-8">Creá tu cuenta</h1>
      <p className="text-sm text-[#565A61] leading-relaxed mt-3">
        Bienvenida al archivo. Con tu cuenta vas a ver tus piezas con su ficha digital y certificado,
        acceder antes que nadie a las colecciones nuevas y recibir beneficios exclusivos para clientas.
      </p>
      {!token && <p data-testid="cc-no-token" className="mt-4 text-sm text-[#9E2A2B] bg-[#9E2A2B]/10 p-3">Este enlace no es válido. Pedile a ARCHIVE LAB uno nuevo respondiendo tu email de compra.</p>}
      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label className="dossier-label text-[10px] text-[#565A61]">Tu nombre</Label>
          <Input data-testid="cc-name" className="mt-1.5" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nombre y apellido" />
        </div>
        <div>
          <Label className="dossier-label text-[10px] text-[#565A61]">Contraseña (mínimo 8 caracteres)</Label>
          <Input data-testid="cc-password" type="password" className="mt-1.5" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="••••••••" />
        </div>
        <div>
          <Label className="dossier-label text-[10px] text-[#565A61]">Repetir contraseña</Label>
          <Input data-testid="cc-password2" type="password" className="mt-1.5" value={form.password2} onChange={(e) => setForm({ ...form, password2: e.target.value })} placeholder="••••••••" />
        </div>
        <button data-testid="cc-submit" disabled={busy || !token} className="btn-ink w-full px-6 py-3.5 dossier-label disabled:opacity-50">
          {busy ? "Creando…" : "Crear mi cuenta"}
        </button>
      </form>
      <p className="dossier-label text-[10px] text-[#858A91] mt-6 leading-relaxed">
        Este enlace es personal y vence a los 7 días. Si expiró, respondé tu email de compra y te mandamos uno nuevo.
      </p>
      <Link to="/" className="dossier-label text-[10px] text-[#565A61] hover:text-[#171719] inline-block mt-6">← Volver a la tienda</Link>
    </div>
  );
}
